import { atom } from "recoil";
import { ResponseGetTransportationOptions } from "../../services/OpenAPI";

export const transportationOptionsState = atom<
  ResponseGetTransportationOptions[] | null
>({
  key: "transportationOptionsState",
  default: null,
});
